module.exports = __webpack_public_path__ + "static/pattern-coulumn-by-number-4b4da48d22baec06c5f415af87128299.png";